/**
 * CRO popup — email → SMS → success (CHEEKY10).
 * Uses window.TBP.subscribe / applySubscriberDiscount from tbp-subscribe.js.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-tbp-cro]');
  if (!root) return;

  var cfg = {
    minTime: Number(root.getAttribute('data-min-time') || 12000),
    scrollPct: Number(root.getAttribute('data-scroll') || 20),
    exitMin: Number(root.getAttribute('data-exit-min') || 6000),
    scrollDelay: Number(root.getAttribute('data-scroll-delay') || 400),
    exitEnabled: root.getAttribute('data-exit-intent') !== 'false',
    discountCode:
      (window.TBP_SUBSCRIBE && window.TBP_SUBSCRIBE.discountCode) || 'CHEEKY10',
  };

  var step = 1;
  var email = '';
  var hasSeen = false;
  var minTimeElapsed = false;
  var exitReady = false;
  var scrollMet = false;
  var mountedAt = Date.now();
  var isOpen = false;
  var pendingAfterCart = false;

  var backdrop = root.querySelector('[data-tbp-cro-backdrop]');
  var panel1 = root.querySelector('[data-tbp-cro-step="1"]');
  var panel2 = root.querySelector('[data-tbp-cro-step="2"]');
  var panelOk = root.querySelector('[data-tbp-cro-step="success"]');
  var emailForm = root.querySelector('[data-tbp-cro-email-form]');
  var phoneForm = root.querySelector('[data-tbp-cro-phone-form]');
  var emailInput = root.querySelector('[data-tbp-cro-email]');
  var phoneInput = root.querySelector('[data-tbp-cro-phone]');
  var smsConsent = root.querySelector('[data-tbp-cro-sms]');
  var errorEls = root.querySelectorAll('[data-tbp-cro-error]');
  var codeEl = root.querySelector('[data-tbp-cro-code]');
  var closeBtns = root.querySelectorAll('[data-tbp-cro-close]');
  var skipBtn = root.querySelector('[data-tbp-cro-skip]');

  function setError(msg) {
    errorEls.forEach(function (el) {
      el.textContent = msg || '';
      el.classList.toggle('is-visible', Boolean(msg));
    });
  }

  function showStep(next) {
    step = next;
    if (panel1) panel1.hidden = next !== 1;
    if (panel2) panel2.hidden = next !== 2;
    if (panelOk) panelOk.hidden = next !== 'success';
  }

  function cartIsOpen() {
    var drawer = document.querySelector('cart-drawer');
    return !!(drawer && drawer.classList.contains('active'));
  }

  function hideForCart() {
    if (!isOpen) return;
    isOpen = false;
    hasSeen = false;
    pendingAfterCart = true;
    root.hidden = true;
    document.body.classList.remove('tbp-cro-open');
  }

  function open() {
    if (isOpen || hasSeen) return;
    if (cartIsOpen()) {
      pendingAfterCart = true;
      return;
    }
    hasSeen = true;
    isOpen = true;
    pendingAfterCart = false;
    root.hidden = false;
    document.body.classList.add('tbp-cro-open');
    showStep(1);
    setError('');
    try {
      if (emailInput) emailInput.focus();
    } catch (e) {}
  }

  function close() {
    isOpen = false;
    root.hidden = true;
    document.body.classList.remove('tbp-cro-open');
    try {
      localStorage.setItem('cro-popup-shown', 'true');
      localStorage.setItem(
        'cro-popup-expiry',
        String(Date.now() + 7 * 24 * 60 * 60 * 1000)
      );
    } catch (e) {}
    showStep(1);
    email = '';
    if (emailInput) emailInput.value = '';
    if (phoneInput) phoneInput.value = '';
    if (smsConsent) smsConsent.checked = false;
    setError('');
  }

  function formatPhone(value) {
    var cleaned = value.replace(/\D/g, '').slice(0, 10);
    if (cleaned.length <= 3) return cleaned;
    if (cleaned.length <= 6) return '(' + cleaned.slice(0, 3) + ') ' + cleaned.slice(3);
    return (
      '(' +
      cleaned.slice(0, 3) +
      ') ' +
      cleaned.slice(3, 6) +
      '-' +
      cleaned.slice(6, 10)
    );
  }

  function msUntilMin() {
    return Math.max(0, cfg.minTime - (Date.now() - mountedAt));
  }

  function tryOpen() {
    if (!hasSeen) open();
  }

  function applySuccessDiscount() {
    var code = cfg.discountCode;
    if (codeEl) codeEl.textContent = code;
    try {
      localStorage.setItem('tbp-subscriber-discount', code);
      sessionStorage.setItem('tbp-subscriber-discount', code);
      localStorage.setItem('user-subscribed', 'true');
    } catch (e) {}

    var apply =
      window.TBP && typeof window.TBP.applySubscriberDiscount === 'function'
        ? window.TBP.applySubscriberDiscount(code)
        : window.TBP && typeof window.TBP.applyDiscountCode === 'function'
          ? window.TBP.applyDiscountCode(code, { open: false, forcePersist: true })
          : Promise.resolve();

    Promise.resolve(apply)
      .catch(function () {})
      .then(function () {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('discount', code);
          window.history.replaceState({}, '', url.toString());
        } catch (e) {}
      });
  }

  function setBusy(form, busy) {
    var btn = form && form.querySelector('[type="submit"]');
    if (!btn) return;
    btn.disabled = busy;
    if (busy) {
      btn.dataset.tbpLabel = btn.dataset.tbpLabel || btn.textContent;
      btn.textContent = '…';
    } else if (btn.dataset.tbpLabel) {
      btn.textContent = btn.dataset.tbpLabel;
    }
  }

  function subscribe(payload) {
    if (window.TBP && typeof window.TBP.subscribe === 'function') {
      return window.TBP.subscribe(payload);
    }
    return Promise.reject(new Error('Subscribe client not loaded'));
  }

  function gateOnMount() {
    try {
      if (localStorage.getItem('user-subscribed') === 'true') {
        hasSeen = true;
        return;
      }
      var shown = localStorage.getItem('cro-popup-shown');
      var expiry = localStorage.getItem('cro-popup-expiry');
      if (shown && expiry) {
        if (Date.now() > parseInt(expiry, 10)) {
          localStorage.removeItem('cro-popup-shown');
          localStorage.removeItem('cro-popup-expiry');
        } else {
          hasSeen = true;
        }
      } else if (shown) {
        hasSeen = true;
      }
    } catch (e) {}
  }

  gateOnMount();
  if (hasSeen) return;

  var cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer && window.MutationObserver) {
    new MutationObserver(function () {
      if (cartIsOpen()) {
        hideForCart();
        return;
      }
      if (pendingAfterCart && !hasSeen && !isOpen) {
        pendingAfterCart = false;
        setTimeout(tryOpen, 700);
      }
    }).observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
  }

  setTimeout(function () {
    exitReady = true;
  }, cfg.exitMin);

  setTimeout(function () {
    minTimeElapsed = true;
  }, cfg.minTime);

  setTimeout(function () {
    tryOpen();
  }, cfg.minTime);

  if (cfg.exitEnabled) {
    document.addEventListener('mouseleave', function (e) {
      if (!exitReady || hasSeen) return;
      if (e.clientY <= 0) tryOpen();
    });

    if (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) {
      var lastY = window.scrollY;
      var lastT = Date.now();
      window.addEventListener(
        'scroll',
        function () {
          if (!exitReady || hasSeen) return;
          var y = window.scrollY;
          var t = Date.now();
          var dy = y - lastY;
          var dt = t - lastT || 1;
          var velocity = dy / dt;
          lastY = y;
          lastT = t;
          if (velocity < -0.9 && y < 240) tryOpen();
        },
        { passive: true }
      );
    }
  }

  window.addEventListener(
    'scroll',
    function () {
      var docHeight = document.documentElement.scrollHeight - window.innerHeight;
      var scrolled = docHeight > 0 ? (window.scrollY / docHeight) * 100 : 0;
      if (scrolled >= cfg.scrollPct && !scrollMet) {
        scrollMet = true;
        setTimeout(tryOpen, msUntilMin() + cfg.scrollDelay);
      }
    },
    { passive: true }
  );

  closeBtns.forEach(function (btn) {
    btn.addEventListener('click', close);
  });
  if (backdrop) backdrop.addEventListener('click', close);

  if (phoneInput) {
    phoneInput.addEventListener('input', function () {
      phoneInput.value = formatPhone(phoneInput.value);
    });
  }

  if (emailForm) {
    emailForm.addEventListener('submit', function (e) {
      e.preventDefault();
      setError('');
      var value = emailInput ? emailInput.value.trim() : '';
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        setError('Please enter a valid email');
        return;
      }
      email = value;
      setBusy(emailForm, true);
      subscribe({
        email: email,
        firstName: email.split('@')[0],
        step: 1,
        signupSource: 'CRO Popup',
        tags: ['newsletter', 'first-order-10off', 'cro-popup'],
        metaLeadContentName: 'CRO Popup - Email',
      })
        .then(function (result) {
          if (result && result.discountCode) cfg.discountCode = result.discountCode;
          // Apply as soon as email is saved so checkout cookie is set early
          if (window.TBP && typeof window.TBP.applySubscriberDiscount === 'function') {
            window.TBP.applySubscriberDiscount(cfg.discountCode).catch(function () {});
          } else if (window.TBP && typeof window.TBP.applyDiscountCode === 'function') {
            window.TBP.applyDiscountCode(cfg.discountCode, { open: false, forcePersist: true }).catch(function () {});
          }
          showStep(2);
          setError('');
          try {
            if (phoneInput) phoneInput.focus();
          } catch (err) {}
        })
        .catch(function (err) {
          setError((err && err.message) || 'Failed to sign up');
        })
        .finally(function () {
          setBusy(emailForm, false);
        });
    });
  }

  if (phoneForm) {
    phoneForm.addEventListener('submit', function (e) {
      e.preventDefault();
      setError('');
      if (!smsConsent || !smsConsent.checked) {
        setError('Please agree to receive SMS messages to continue');
        return;
      }
      var phone = phoneInput ? phoneInput.value.trim() : '';
      if (!phone) {
        setError('Please enter a phone number');
        return;
      }
      setBusy(phoneForm, true);
      subscribe({
        email: email,
        firstName: email.split('@')[0],
        phone: phone,
        smsConsent: true,
        step: 2,
        signupSource: 'CRO Popup',
        tags: ['newsletter', 'first-order-10off', 'cro-popup', 'sms'],
        metaLeadContentName: 'CRO Popup - Email + SMS',
      })
        .then(function (result) {
          if (result && result.discountCode) cfg.discountCode = result.discountCode;
          showStep('success');
          applySuccessDiscount();
        })
        .catch(function (err) {
          setError((err && err.message) || 'Failed to add phone');
        })
        .finally(function () {
          setBusy(phoneForm, false);
        });
    });
  }

  if (skipBtn) {
    skipBtn.addEventListener('click', function () {
      try {
        localStorage.setItem('user-subscribed', 'true');
      } catch (e) {}
      showStep('success');
      applySuccessDiscount();
    });
  }
})();
